module.exports = __webpack_public_path__ + "img/hellas-verona.9be62da7.png";